import {
    CLEAR_GLOBAL_NOTIFICATION,
    SET_GLOBAL_NOTIFICATION,
} from "./constants";

const initialState = {
    globalNotifications: {
        message: '',
        isOpen: false,
        notificationKey: '',
    },
};

const globalNotifications = (state = initialState.globalNotifications, { type, payload }) => {
    switch (type) {
        case SET_GLOBAL_NOTIFICATION:
        case CLEAR_GLOBAL_NOTIFICATION:
            return {...state, ...payload};
        default:
            return state;
    }
}

export default globalNotifications;